import Connector from './connector';
import { ConnectorProps } from './ReportTile.proptype';
import { ReportTile as Component } from '../../components';

export interface ReportTileProps extends Omit<ConnectorProps, 'component'> {}

export const ReportTile = (props: ReportTileProps) => <Connector {...props} component={Component} />;
